interface config {
    css: {
        runtime: string;
        esfr: string;
    };
    script: string;
    initialized: boolean;
}

const vhtConfig: config = {
    css: {
        runtime: "https://b28991bfdad25dc3.scheduler-rt.getmindful.com/vht-conversation-bridge-runtime.css",
        esfr: "https://b28991bfdad25dc3.scheduler-rt.getmindful.com/vht-conversation-bridge-brand.css"
    },
    script: "https://b28991bfdad25dc3.scheduler-rt.getmindful.com/vht-conversation-bridge-runtime.js",
    initialized: false
};

export function intializeVht(): void {
    const vhtRoot: HTMLElement | null = document.querySelector("#vhtRoot");   
    if (vhtRoot && vhtConfig.initialized === false) {
        const createStylesheet = (href: string | undefined) => {
            if (!href) {
                console.warn("Stylesheet href is undefined.");
                return null;
            }
            let link: HTMLLinkElement = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            return link;
        };
        const lang: string = document.documentElement.lang;
        const frag: DocumentFragment = document.createDocumentFragment();
        const script: HTMLScriptElement = document.createElement("script");
        const data: DOMStringMap = vhtRoot.dataset;
        const cssBase: HTMLLinkElement | null = createStylesheet(data.cssBase);
        let cssRuntime: HTMLLinkElement | null = createStylesheet(vhtConfig.css.runtime);

        // Append styles to frag.
        if (cssBase && cssRuntime) {
            frag.appendChild(cssBase);
            frag.appendChild(cssRuntime);
        }
        else {
            console.log("One or more stylesheets failed to load. Custom styles may not be applied correctly.");
        }


        let isAlternateLang: boolean | undefined = (lang === "es" || lang === "fr")
            || (window.LayoutJs.isDev && (window.location.search.includes("lang=es") || window.location.search.includes("lang=fr")));

        if (isAlternateLang) {
            let cssLang: HTMLLinkElement | null = createStylesheet(vhtConfig.css.esfr);
            if (!cssLang) {
                return console.warn("Alternate language stylesheet failed to load. Custom styles may not be applied correctly for alternate languages.");
            }
            frag.appendChild(cssLang);
        }

        // Set script properties.
        script.defer = true;
        script.src = vhtConfig.script;

        // Append sources to document.
        document.head.appendChild(frag);
        document.body.appendChild(script);

        vhtConfig.initialized = true;
    }
}

const vhtModal: HTMLDivElement | null = document.querySelector("#vhtCallbackModal");
if (vhtModal) {
    vhtModal.addEventListener("closeme.zf.reveal", intializeVht);
}